import React, { useCallback, useEffect, useState } from "react";
import "./EditCountry.css";
import Header from "../header/Header";
import {
  getAllFields,
  getAllCountries,
  UpdateCountry,
  DeleteCountry,
} from "../../services/ApiService";
import { Button, Modal, AutoComplete, Checkbox, Row, Col, message } from "antd";
import Sidebar from "../Sidebar/Sidebar";
import { hasPermission } from "../GlobalFunction";

const EditCountry = () => {
  const canDelete = hasPermission("country_list", "delete");
  const [fields, setFields] = useState([]);
  const [countries, setCountries] = useState([]);
  const [IsGetStartClick, setIsGetStartClick] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [checkedFields, setCheckedFields] = useState([]);
  const [countryInput, setCountryInput] = useState(""); // NEW STATE

  const fetchCountries = async () => {
    try {
      const res = await getAllCountries(1);
      if (res.responseCode === 200) {
        setCountries(res.country_list);
      } else {
        throw new Error("Failed to fetch Country List");
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
      message.error("Failed to fetch Country");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const fieldsRes = await getAllFields();
        if (fieldsRes.response_code === 200) {
          setFields(fieldsRes.field_list);
        }

        fetchCountries();
      } catch (error) {
        console.error("Error fetching fields and countries:", error);
      }
    };

    fetchData();
  }, []);

  const handleCountrySelect = (value) => {
    setCountryInput(value); // Update input field
    const countryData = countries.find(
      (country) => country.country_name === value
    );
    if (!countryData) {
      setSelectedCountry(null);
      setCheckedFields([]);
      return;
    }
    setSelectedCountry(countryData);
    setIsGetStartClick(false);
    setCheckedFields([]);
  };

  const handleCheckboxChange = useCallback((e, fieldId) => {
    setCheckedFields((prevCheckedFields) =>
      e.target.checked
        ? [...prevCheckedFields, fieldId]
        : prevCheckedFields.filter((id) => id !== fieldId)
    );
  }, []);

  const handleUpdate = async () => {
    try {
      if (checkedFields.length === 0) {
        message.error("At least one field is required.");
        return;
      }

      const body = {
        id: selectedCountry.id,
        form_field: checkedFields.join(","),
      };
      const res = await UpdateCountry(body);
      if (res.responseCode === 200) {
        message.success(res.message);
        setIsGetStartClick(false);
        setSelectedCountry(null);
        setCheckedFields([]);
        setCountryInput(""); // reset input
        fetchCountries();
      } else {
        message.error(res.message);
      }
    } catch (error) {
      message.error("Update failed");
      console.error("Update error:", error);
    }
  };

  const handleGetStarted = () => {
    setIsGetStartClick(true);
    const selectedFields = selectedCountry?.form_field
      ? selectedCountry.form_field
          .split(",")
          .map((field) => Number(field.trim()))
      : [];
    setCheckedFields(selectedFields);
  };

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  const handleDelete = async () => {
    try {
      const res = await DeleteCountry(selectedCountry.id);
      if (res.responseCode === 200) {
        message.success("Country Deleted Successfully");
        setCountries((prevCountries) =>
          prevCountries.filter(
            (country) => country.country_name !== selectedCountry.country_name
          )
        );
        setModalVisible(false);
        setSelectedCountry(null);
        setCheckedFields([]);
        setCountryInput(""); // reset input
        setIsGetStartClick(false);
      } else {
        message.error(res.message);
      }
    } catch (error) {
      message.error("Error In Deleting Country");
      console.error("Error deleting country:", error);
    }
  };

  return (
    <div className="main-box">
      <Sidebar activeId={2} />
      <main className="main-content">
        <div
          style={{ display: "flex", flexDirection: "column", height: "100vh" }}
        >
          <Header title="Country Management" />
          <div
            style={{
              flex: 1,
              padding: "2rem",
              boxSizing: "border-box",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div className="country-box">
              <div>
                <p
                  style={{
                    fontFamily: "DM Sans",
                    fontSize: "1rem",
                    fontWeight: 700,
                    marginTop: 0,
                  }}
                >
                  Choose Country
                </p>
                <AutoComplete
                  placeholder="Select Country"
                  className="country-select"
                  style={{ width: 200 }}
                  value={countryInput}
                  onSearch={(text) => setCountryInput(text)} // allows typing
                  onSelect={handleCountrySelect} // when user selects from list
                  options={countries.map((country) => ({
                    value: country.country_name,
                  }))}
                  filterOption={(inputValue, option) =>
                    option.value
                      .toLowerCase()
                      .includes(inputValue.toLowerCase())
                  }
                />
                {!IsGetStartClick ? (
                  <Button
                    type="primary"
                    onClick={handleGetStarted}
                    disabled={!selectedCountry}
                    style={{ marginLeft: "2rem" }}
                  >
                    Get Started
                  </Button>
                ) : (
                  <Button
                    type="primary"
                    style={{ marginLeft: "2rem" }}
                    onClick={handleUpdate}
                  >
                    Update
                  </Button>
                )}
              </div>
            </div>
            {IsGetStartClick && (
              <>
                <div
                  className="country-field"
                  style={{
                    marginTop: "1rem",
                    height: "55vh",
                    overflowY: "auto",
                  }}
                >
                  <Row
                    gutter={[16, 16]}
                    className="custom-scrollbar"
                    style={{ height: "100%", overflowY: "auto" }}
                  >
                    {fields?.map((field) => (
                      <Col span={12} key={field.id}>
                        <Checkbox
                          value={field.id}
                          checked={checkedFields.includes(field.id)}
                          onChange={(e) => handleCheckboxChange(e, field.id)}
                        >
                          {field.name}
                        </Checkbox>
                      </Col>
                    ))}
                  </Row>
                </div>
                <div
                  style={{
                    marginTop: "0.5rem",
                    display: "flex",
                    alignContent: "center",
                    justifyContent: "flex-end",
                  }}
                >
                  {canDelete && (
                    <Button
                      danger
                      onClick={() => setModalVisible(true)}
                      style={{ backgroundColor: "red", color: "white" }}
                    >
                      Delete
                    </Button>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </main>

      <Modal
        open={modalVisible}
        onCancel={handleModalCancel}
        footer={null}
        centered
        closable={false}
        width={400}
        bodyStyle={{ padding: "1rem" }}
      >
        <h4
          style={{
            fontFamily: "DM Sans",
            fontWeight: 600,
            fontSize: "1rem",
            textAlign: "center",
            marginTop: 0,
            marginBottom: "0.5rem",
          }}
        >
          Are you sure you want to delete this country?
        </h4>
        <p
          style={{
            fontFamily: "DM Sans",
            fontSize: "0.8rem",
            color: "#6F6C90",
            textAlign: "center",
          }}
        >
          Deleting this country will permanently remove all its associated
          fields from the onboarding form. This action cannot be undone.
        </p>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            type="primary"
            danger
            onClick={handleDelete}
            style={{ backgroundColor: "red", color: "white" }}
          >
            Delete Country
          </Button>
          <Button onClick={handleModalCancel}>Cancel</Button>
        </div>
      </Modal>
    </div>
  );
};

export default EditCountry;
